// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__9sNrR","checkmark":"Checkbox_checkmark__EQjgy","label":"Checkbox_label__GOlfR","selected":"Checkbox_selected__hZG3d"};